import { render, staticRenderFns } from "./ExternalFormRow.vue?vue&type=template&id=63898750&scoped=true"
import script from "./ExternalFormRow.vue?vue&type=script&lang=ts"
export * from "./ExternalFormRow.vue?vue&type=script&lang=ts"
import style0 from "./ExternalFormRow.vue?vue&type=style&index=0&id=63898750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63898750",
  null
  
)

export default component.exports